import { render, staticRenderFns } from "./TheFeedbackButton.vue?vue&type=template&id=ec3b8ec4&"
import script from "./TheFeedbackButton.vue?vue&type=script&lang=js&"
export * from "./TheFeedbackButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports